import { render, staticRenderFns } from "./VerificationPopup.vue?vue&type=template&id=7b2235ed&scoped=true"
import script from "./VerificationPopup.vue?vue&type=script&lang=js"
export * from "./VerificationPopup.vue?vue&type=script&lang=js"
import style0 from "./VerificationPopup.vue?vue&type=style&index=0&id=7b2235ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2235ed",
  null
  
)

export default component.exports